var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.386 66.573-2.283-2.284c-3.445-3.45-3.445-9.064-.001-12.515l.002-.002L51.78 9.106c3.442-3.447 9.058-3.45 12.525 0l8.524 8.534c3.446 3.45 3.446 9.064-.002 12.516L30.16 72.82c-3.442 3.447-9.058 3.45-12.525 0l-2.264-2.264-2.276 2.274a3.226 3.226 0 0 0-.002 4.552l8.539 8.534a3.229 3.229 0 0 0 4.555 0l25.6-25.602c3.437-3.443 9.047-3.481 12.526.002l2.268 2.269 5.541-5.542a2.817 2.817 0 1 1 3.984 3.984l-1.283 1.283 25.253 25.254a8.846 8.846 0 0 1 0 12.512 8.847 8.847 0 0 1-12.512 0L62.31 74.822l-1.287 1.287a2.817 2.817 0 1 1-3.983-3.984l5.557-5.557-2.272-2.273a3.22 3.22 0 0 0-4.554.002L30.17 89.9c-3.452 3.452-9.075 3.448-12.522 0l-8.54-8.535c-3.446-3.45-3.446-9.065.005-12.52l2.273-2.272z",
    fill: "#E3E3E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryServices);
export default __webpack_public_path__ + "static/media/category-services.c1dd617dd3cadd9ebd81b71910eeae25.svg";
export { ForwardRef as ReactComponent };